import { useToast, TOAST_REMOVE_DELAY } from '../hooks/useToast';

import { Toast } from './Toast';

export function Toaster() {
	const { toasts } = useToast();

	return (
		<Toast.Provider duration={TOAST_REMOVE_DELAY}>
			{toasts.map(({ id, title, action, ...props }) => (
				<Toast.Root key={id} {...props}>
					<div className="grid gap-1">
						{title && <Toast.Title>{title}</Toast.Title>}
					</div>
					{action}
					<Toast.Close />
				</Toast.Root>
			))}
			<Toast.Viewport />
		</Toast.Provider>
	);
}
